var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98049 27.9249L4.09324 29.2141L2 20.7652L24.0445 14.9361M9.98049 27.9249L13.5269 50.1984L30.7635 47.2511M9.98049 27.9249L26.3288 24.3451M42.677 20.7652L47.4626 19.7173L45.304 9.36902L24.0445 14.9361M42.677 20.7652L48 44.3038L30.7635 47.2511M42.677 20.7652L26.3288 24.3451M24.0445 14.9361L26.3288 24.3451M24.0445 14.9361C22.8016 7.99363 17.5031 0.134186 12.8587 4.39137C7.51296 9.29144 16.7181 16.8734 24.0445 14.9361ZM24.0445 14.9361C22.7781 7.86263 26.1769 -1.10766 31.5016 1.4441C37.6516 4.39137 31.011 13.094 24.0445 14.9361ZM26.3288 24.3451L30.7635 47.2511",
    stroke: "#1B3B5F",
    strokeWidth: 1.88139
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftBox);
export default __webpack_public_path__ + "static/media/giftBox.4439ab672589e725e535fc4610f08e1f.svg";
export { ForwardRef as ReactComponent };